import L from 'leaflet'

interface ScaleOptions {
  metric?: boolean
  imperial?: boolean
  nautic?: boolean
}

class ScaleElane extends L.Control.Scale {
  private _mScale!: HTMLElement
  private _iScale!: HTMLElement
  private _nScale!: HTMLElement

  constructor(options: ScaleOptions) {
    super(options)
    this._addScales(options)
  }

  private _addScales(
    options: ScaleOptions,
    className?: string,
    container?: HTMLElement
  ) {
    if (options.metric) {
      this._mScale = L.DomUtil.create('div', className, container)
    }
    if (options.imperial) {
      this._iScale = L.DomUtil.create('div', className, container)
    }
    if (options.nautic) {
      this._nScale = L.DomUtil.create('div', className, container)
    }
  }

  _updateScales(maxMeters: number) {
    if (this.options.metric && maxMeters) {
      this['_updateMetric'](maxMeters)
    }
    if (this.options.imperial && maxMeters) {
      this['_updateImperial'](maxMeters)
    }
    if ((this.options as any).nautic && maxMeters) {
      this._updateNautic(maxMeters)
    }
  }

  private _updateNautic(maxMeters: number) {
    const ratio = maxMeters / 1852
    const text =
      maxMeters >= 1852
        ? this['_getRoundNum'](ratio)
        : ratio > 0.1
        ? Math.round(10 * ratio) / 10
        : Math.round(100 * ratio) / 100
    this._nScale.style.padding = '0px'
    this._nScale.style['text-align'] = 'center'
    this['_updateScale'](this._nScale, `${text}nm`, text / ratio)
  }
}

export default ScaleElane
